import { Moment } from 'moment';
import { getDateTimeWithDst } from '../../../Utils/dates.util';

// HELPER FOR GETTING DATE TIME WITH DST OF ORIGIN DATE TIME
export const prepareDateTimeWithOriginDst = (
	originDate: string,
	originTime: string,
	date: string,
	time: string,
): Moment => {
	return getDateTimeWithDst(originDate, date, time, originTime);
};
